import { isDefined } from "@omni/utils/helper.utils";
import { createContext, ReactNode, use } from "react";

import { FaqQuestion } from "@/components/General/Faq/types/faqQuestion.types";

type AccordionItemContextValue = {
    open: boolean;
    question: FaqQuestion;
};

type AccordionItemContextProviderProps = {
    open: boolean;
    question: FaqQuestion;
    children: ReactNode;
};

export const AccordionItemContext = createContext<
    AccordionItemContextValue | undefined
>(undefined);
AccordionItemContext.displayName = "AccordionItemContext";

export const AccordionItemContextProvider = ({
    open,
    question,
    children
}: AccordionItemContextProviderProps) => {
    return (
        <AccordionItemContext
            value={{
                open: open,
                question: question
            }}
        >
            {children}
        </AccordionItemContext>
    );
};

export const useAccordionItemContext = () => {
    const context = use<AccordionItemContextValue | undefined>(
        AccordionItemContext
    );

    if (!isDefined(context)) {
        throw new Error(`${AccordionItemContext.displayName} is undefined.`);
    }

    return context;
};
